class CompareInput extends HTMLElement {
    constructor() {
        super();
 
    }
  connectedCallback() {
    requestAnimationFrame(() => this.initCard());
  }
  initCard(){
    this.compareButton = document.querySelector(".compare-button."+this.dataset.sectionId);
        this.compareCount = document.querySelector(".compare-product-number."+this.dataset.sectionId);
        this.addEventListener('change', this.changeHandler.bind(this));
  }

    changeHandler(e) {
        let section = this.dataset.sectionId;
        let isChecked = e.target.checked;
        window.input_section = window.input_section || [];
        if (window.input_section.length != 0 && window.input_section[0] != section) {
            e.target.checked = false;
            alert("You can compare only similar products.");
            return;
        }

        if (isChecked) {
            this.handleAddition(section, e);
        } else {
            this.handleRemoval();
        }
        this.updateCompareButton();
    }

    handleAddition(section, e) {        
        if (window.input_section.length > 0) {
            if (window.input_section.length <= 2) {
                    window.input_section.push(section);
                    this.updateCompareCount();
            } else {
                e.target.checked = false;
                alert("You can only compare 3 products at a time.");
            }
        } else {
            window.input_section.push(section);
            this.updateCompareCount();
        }
    }

    handleRemoval() {
        if (window.input_section.length > 0) {
            window.input_section.pop();
            this.updateCompareCount();
        }
    }

    updateCompareCount() {
        this.compareCount.innerHTML = `(${window.input_section.length})`;
        if(!window.input_section.length){
            
            this.compareButton.style.display = "none";
        }
    }

    updateCompareButton() {
        this.compareButton.style.display = window.input_section.length ? "table" : "none";
    }
}

customElements.define('compare-input', CompareInput);